import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { genericScalars } from '../lib/graphql/helpers';
import { order_by } from '../lib/generated/zeus';
import type { ApolloError } from '@apollo/client';

export const queryFirstShiftName = 'queryFirstShift';

const useQueryFirstShift = (
  id: string | undefined,
  onError: (e: ApolloError) => void,
  onCompleted?: (start_time: string | undefined) => void
) =>
  useTypedQuery(
    {
      shift: [
        {
          where: {
            team_role_assignment: { team_id: { _eq: id } },
          },
          order_by: [{ start_time: order_by.asc }],
          limit: 1,
        },
        { start_time: true },
      ],
    },
    {
      apolloOptions: {
        onCompleted: (data) => {
          if (onCompleted !== undefined) {
            const shift = data.shift[0] ?? { start_time: undefined };

            onCompleted(shift.start_time);
          }
        },
        onError,
        skip: id === undefined,
      },

      scalars: genericScalars,
      operationOptions: {
        operationName: queryFirstShiftName,
      },
    }
  );

export default useQueryFirstShift;
